import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  useTheme,
} from '@mui/material';

import CustomDialogModal from './Custom';

const MapDialogModal = ({
  title,
  children,
  isOpen,
  onClose,
  id = '',
  maxWidth = 'md',
}) => {
  const theme = useTheme();

  const handleClose = () => {
    onClose?.();
  };

  return (
    <CustomDialogModal open={isOpen} onClose={handleClose} maxWidth={maxWidth}>
      {title && <DialogTitle>{title}</DialogTitle>}

      {children && <DialogContent>{children}</DialogContent>}

      <DialogActions>
        <Button
          variant="contained"
          id={id}
          onClick={handleClose}
          sx={{
            fontWeight: 600,
            '&:hover': {
              backgroundColor: theme.primary,
              color: theme.text1,
            },
          }}
        >
          Cerrar
        </Button>
      </DialogActions>
    </CustomDialogModal>
  );
};

export default MapDialogModal;
